import {
  API_BASE_URL,
  AUTH_TOKEN_KEY,
  HIGHEST_OFFER_FETCH,
  USER_OFFER_POST,
  VALIDATE_OFFER,
  USER_OFFER_DETAILS_FETCH,
  USER_OFFER_HISTORY_LIST,
  USER_OFFER_PENDING_LIST,
  USER_OFFER_ACCEPTED_LIST,
  PENDING_OFFER_LIST_NEW,
  PENDING_OFFER_LIST,
  UPDATE_OFFER_USER,
  PROMISE_FULFILLED,
  DELETE_OFFER_USER,
  ACCEPT_OFFER_REQUEST,
  FETCH_MAX_AMOUNT,
  BID_VALIDATION,
  FETCH_BID_VALIDATION,
} from '../constants';

import fetch from '../utils/Api';
import axios from 'axios';

const ENDPOINT = '/products';

export const doFetchHighestOffer = productId => ({
  type: HIGHEST_OFFER_FETCH,
  payload: axios.get(`${API_BASE_URL}${ENDPOINT}/${productId}`)
    .then((res) => res.data)
})

export const doPostUserOffer = (payload) => ({
  type: USER_OFFER_POST,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .post(`/users/bids`, payload)
    .then(res => res.data)
})

export const resetPostUserOffer = () => {
  return (dispatch) => {
    dispatch({type: `${USER_OFFER_POST}${"_RESET"}`})
  }
}

export const doValidateOffer = (id, payload) => ({
  type: VALIDATE_OFFER,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .post(`/products/${id}/bids`, payload)
    .then(response => response.data)
})

export const doFetchOfferHistory = (query) => ({
  type: USER_OFFER_HISTORY_LIST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get(`/users/bids`, {params: {...query}})
    .then(response => response.data)
})

export const doFetchOfferPending = (query) => ({
  type: USER_OFFER_PENDING_LIST,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .get(`/users/bids`, {params: {status: "pending", ...query}})
  .then(response => response.data)
})

export const doFetchOfferAccepted = (query) => ({
  type: USER_OFFER_ACCEPTED_LIST,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .get(`/users/bids`, {params: {status: "processed", ...query}})
  .then(response => response.data)
})

export const doFetchOfferDetails = (bidId) => ({
  type: USER_OFFER_DETAILS_FETCH,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .get(`/users/bids/${bidId}`)
  .then(response=>response.data)
})

export const doPendingOfferListNew = (product_variant_id, size_id) => ({
  type: PENDING_OFFER_LIST_NEW,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get(`/users/variants/${product_variant_id}/sizes/${size_id}/bids`)
    .then(response => response.data)
})

export const doPendingOfferList = (query) => ({
  type: PENDING_OFFER_LIST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .get(`/users/sells/${query}/bids`)
    .then(response => response.data)
})

export const doAcceptOfferRequest = (id, payload) => ({
  type: ACCEPT_OFFER_REQUEST,
  payload: fetch({
    Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
    .post(`/users/sells/${id}/bids`, payload)
    .then(response => response.data)
})

export const updateOffer = (bidId, payload) => ({
  type: UPDATE_OFFER_USER,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .put(`/users/bids/${bidId}`, payload)
  .then(response=>response.data)
})

export const setUpdateToDefault = () => ({
  type: `${UPDATE_OFFER_USER}_SET_DEFAULT`,
  payload: {
    data: {},
    status_code: null,
    data: null
  }
})

export const deleteOffer = (bidId) => ({
  type: DELETE_OFFER_USER,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .delete(`/users/bids/${bidId}`)
  .then(response=>response.data)
})

export const doFetchMaxAmount = (bidId) => ({
  type: FETCH_MAX_AMOUNT,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .get(`/users/bids/${bidId}/max_amount`)
  .then(response=>response.data)
})

export const doBidValidation = () => ({
  type: FETCH_BID_VALIDATION,
  payload: fetch({
    Authorization: 'Bearer' + localStorage.getItem(AUTH_TOKEN_KEY)
  })
  .get(`/users/bids/validation`)
  .then(response=>response.data)
})
